(function(){

  var comp = document.querySelector('.js-filters-post');
  if(!comp) return;

  function get_type() {
    let comp = document.querySelector('.js-filters-post');
    return comp.dataset.type;
  }

  function get_actions() {

    var type = get_type();

    if(get_type() == 'agenda'){

      return {
        action_publication : 'wami_get_agenda',
      }
      
    }
    
    return {
      action_date : 'wami_get_publications_date',
      action_tag : 'wami_get_publications_tags',
      action_publication : 'wami_get_publication',
    }

  }

  function removeItemOnce(arr, value) {
    var index = arr.indexOf(value);
    if (index > -1) {
      arr.splice(index, 1);
    }
    return arr;
  }

  function reset_cator(cator) {

    for(var i in cator) {
      var _cat_slug = cator[i];
      document.querySelector('#' + _cat_slug).checked = false
    }

    return [];

  }
  
  function reset_tag() {
    var filter_tag = document.querySelectorAll('[data-type=tag]');
    filter_tag.forEach((item) => {
      removeItemOnce(item, cat_filters);
    })
  }

  function reset_catand(catand_filter) {

    catand_filter.forEach((item) => {
      item.checked = false;
    });

    reset_filter(true);

  }


  function reset_filter(all = false){
    all_filter.forEach((filter) => {
      var input = filter.querySelector('input');
      if(all) filter.classList.remove('active');
      else if(input.dataset.type != 'tag') filter.classList.remove('active');
      else if(all == 'tag') {
        if(input.dataset.type == 'tag') filter.classList.remove('active');
      }
    });

  }

  function get_publication_tags(args) {

    if(get_type() == 'agenda') return false;
   
    var _data = {
      'action': get_actions().action_tag,
    }

    var data = Object.assign({}, _data, args);
    
    fetch(wami_js.ajaxurl + '?' + new URLSearchParams(data))
    .then(data => data.text())
    .then((tpl) => {

      var tags_result = document.querySelector('.js-tags-result');
      tags_result.innerHTML = tpl;

      var catand_filter = document.querySelectorAll('.js-publications-catand-filter');
      catand_filter.forEach((catand_item) => {
        var type = catand_item.dataset.type;
        if(type == 'tag'){
          catand_item.addEventListener('click', (e) => {
            click_catand(catand_item);            
          });
        }

      });

      var catand_remove_filter = document.querySelectorAll('.js-publications-catand-remove-filter');
      catand_remove_filter.forEach((item) => {
        item.addEventListener('click', (e) => {
          
          var input = item.closest('.filter-item').querySelector('.js-publications-catand-filter')
          if(input.dataset.type == 'tag'){

            tag = false;
            item.closest('.filter-item').classList.remove('active');
            input.checked = false;
  
            get_publications(args);

          }
          

        });
      });

    })

  }


  function click_loadmore() {

    var loadmore = document.querySelector('.js-loadmore');
    if(loadmore){
      
      loadmore.addEventListener('click', (e) => {
  
        e.preventDefault();
        var current_page = parseInt(loadmore.dataset.page);
        current_page = current_page + 1;
        loadmore.dataset.page = current_page;
        
        get_publications({
          cator : cator,
          catand : catand, 
          tag : tag,
          date : date, 
          keyword : keyword,
        }, false, current_page);
    
      });
  
    }

  }

  function get_publication_dates(args) {

    if(get_type() == 'agenda') return false;
   
    var _data = {
      'action': get_actions().action_date,
    }

    var data = Object.assign({}, _data, args);

    // if(cator.length) data.cator = cator;
    // else if(catand) data.catand = catand;
    // if(tag) data.tag = tag;

    var date_result = document.querySelector('.js-date-result');
    
    fetch(wami_js.ajaxurl + '?' + new URLSearchParams(data))
    .then(data => data.text())
    .then((tpl) => {

      date_result.innerHTML = tpl;

      // document.querySelector('.js-filter-date.active').classList.remove('active');
      // document.querySelector('[data-date="' + date + '"]').classList.add('active');

      new Splide( '.splide', {
        autoWidth: true,
        focus    : 0,
        pagination : false
      } ).mount();

      var date_filter = document.querySelectorAll('.js-filter-date');
      date_filter.forEach((date_item) => {

        date_item.addEventListener('click', (e) => {
          date = date_item.dataset.date;
          args.date = date;
          get_publications(args, false);

          date_filter.forEach((_date_item) => {_date_item.classList.remove('active');})
          date_item.classList.add('active');

        })
      });

    })

  }

  //function get_publications(cator, catand, tag = false, date = false, reload_tag = true) {
  function get_publications(args, reload_tag = true, page = false) {

    document.querySelector('#js-loader').classList.add('active');

    var _data = {
      'action': get_actions().action_publication,
    }

    var data = Object.assign({}, _data, args);

    if(page) data.page = page;

    var filters_selected_component = document.querySelector('.js-filters-selected-component');

    var cat_filters = [];
    if(args.catand) cat_filters.push(args.catand);
    if(args.cator.length) for(var i in args.cator) cat_filters.push(args.cator[i]);
    if(args.tag) cat_filters.push(args.tag);
    if(args.keyword) cat_filters.push(args.keyword);

    // ajouter les keywords
    if(cat_filters.length) {

      if(!data.date) get_publication_dates(args);
      if(reload_tag) {
        get_publication_tags(args);
      }
      
    }
    
    fetch(wami_js.ajaxurl + '?' + new URLSearchParams(data))
    .then(data => data.text())
    .then((tpl) => {

        document.querySelector('#js-loader').classList.remove('active');

        if(page) {
          
          var list = containe_publication.querySelector('.publications-list');
          list.innerHTML = list.innerHTML + tpl;

          var loadmore = document.querySelector('.js-loadmore');
          const nbpages = parseInt(loadmore.dataset.nbpages);
          
          if(nbpages <= page) {
            loadmore.hidden = true;
          }

          return;

        }
        
        containe_publication.innerHTML = tpl

        var container = document.querySelector('.js-publications-filters-selected');
        container.innerHTML = '';

        if(cat_filters.length) {

          filters_selected_component.classList.add('active');

          for(var i in cat_filters) {

            var cat_slug = cat_filters[i];
            var input = document.querySelector('#' + cat_slug);
            if(input){
              /** Si input c'est un filtre checkbox ou radio */
              var filter = input.closest('.filter-item');
              var label = filter.querySelector('label').textContent;
              var type = input.dataset.type;
            }else{
              /** Sinon c'est un mot clés */
              var type = 'keyword';
              var label = keyword;
            }

            var new_item = document.createElement("li");
            new_item.insertAdjacentHTML('afterbegin', '<span>' + label + '</span><i class="remove-filter fas fa-times js-publications-remove-filter"></i>');

            new_item.dataset.slug = cat_slug;
            new_item.dataset.type = type;

            container.append(new_item);

            (function(new_item){
              
              new_item.addEventListener('click', (e) => {
                var slug = new_item.dataset.slug;
                var input = document.querySelector('#' + slug);

                if(new_item.dataset.type == 'keyword'){
                  
                  var input = search_keyword.closest('.filter-keyword').querySelector('input');
                  input.value = '';
                  keyword = false;

                  args.keyword = false;
                  args.tag = false,
                  get_publications(args);
                  get_publication_tags(args);

                }else{
                  
                  if(input.classList.contains('js-publications-catand-filter')){
                    var filter = input.closest('.filter-item');
                    filter.querySelector('.remove-filter').click();
                  }else{
                    input.click();
                  }
  
                  if(input.dataset.type != 'tag') {
                    
                    var filter_tag = document.querySelectorAll('[data-type=tag]');
                    filter_tag.forEach((item) => {
                      removeItemOnce(cat_filters, item);
                    })

                  }

                }

                new_item.remove();

              })

            })(new_item)

          }

        }
        else {

          filters_selected_component.classList.remove('active');
          var date_result = document.querySelector('.js-date-result');
          date_result.innerHTML = '';

        }

        click_loadmore();

      }).catch(function (error) {
        console.log('request failed', error)
      });
    
  }

  var click_catand = (catand_item) => {

    var type = catand_item.dataset.type;
      if(type == 'tag') {

        tag = catand_item.value;

        reset_filter('tag');
        
        get_publications({
          cator : cator,
          catand : catand, 
          tag : tag,
          date : false,
          keyword : keyword,
        }, false);

      }else{

        cator = reset_cator(cator);
        catand = catand_item.value;
  
        reset_filter();
  
        var cator_filters = document.querySelectorAll('[data-parent=' + catand+ ']');
        cator_filters.forEach((cator_item) => {
          cator_item.checked = true;
          cator.push(cator_item.value);
        });
                  
        tag = false
        
        get_publications({
          cator : cator,
          catand : catand, 
          tag : tag,
          date : false, 
          keyword : keyword,
        });
        
      }
      
      catand_item.closest('.filter-item').classList.add('active');

  }

  var catand = false; // <= catégorie pour la requette AND (cat parent)
  var cator = []; // <= catégories pour la requette OR (cats enfants)
  var tag = false; // <= tag pour la requette
  var date = false; // <= tag pour la requette
  var keyword = false;

  var containe_publication = document.querySelector('#js-result');
  var all_filter = document.querySelectorAll('.filter-item');

  var search_keyword = document.querySelector('.js-search-keyword');
  search_keyword.addEventListener('click', (e) => {

    e.preventDefault();

    var input = search_keyword.closest('.filter-keyword').querySelector('input');
    keyword = input.value;

    get_publications({
      cator : cator,
      catand : catand, 
      tag : false,
      date : date, 
      keyword : keyword,
    });

  })

  var catand_filter = document.querySelectorAll('.js-publications-catand-filter');
  catand_filter.forEach((catand_item) => {
    catand_item.addEventListener('click', (e) => {

      click_catand(catand_item);
      
    });

  });

  var cator_filter = document.querySelectorAll('.js-publications-cator-filter');
  cator_filter.forEach((cator_item) => {
    cator_item.addEventListener('click', (e) => {

      var cat_slug = cator_item.value;
      
      var cat_parent = cator_item.dataset.parent;
      var parent = document.querySelector('#' + cat_parent);

      if(cat_parent != catand){
        reset_filter();

        catand = parent.value;

        parent.closest('.filter-item').classList.add('active');

        cator = reset_cator(cator);

      }

      document.querySelectorAll('.js-publications-catand-filter').forEach((elem) => {
        elem.checked = false;
      });

      parent.checked = true;

      /** On selectionne et mes à jour la requette */
      if(cator_item.checked){
        cator.push(cat_slug);
      }else{
        removeItemOnce(cator, cat_slug);
      }

      if(!cator.length) {
        parent.closest('.filter-item').querySelector('.remove-filter').click();
      }else{
        get_publications({
          cator : cator,
          catand : catand, 
          tag : tag,
          date : false, 
          keyword: keyword
        });
      }
      

    });
  });

  var catand_remove_filter = document.querySelectorAll('.js-publications-catand-remove-filter');
  catand_remove_filter.forEach((item) => {
    item.addEventListener('click', (e) => {
      
      var input = item.closest('.filter-item').querySelector('.js-publications-catand-filter')
      if(input.dataset.type == 'tag'){

        tag = false;

      }else{
        
        cator = reset_cator(cator);
        get_publication_tags({
          cator : cator, 
          catand : catand, 
          tag : tag,
          date : false,
          keyword : keyword,
        });

        catand = false;
        
      }
      
      item.closest('.filter-item').classList.remove('active');
      input.checked = false;

      get_publications({
        cator : cator,
        catand : catand, 
        tag : tag,
        date : false, 
        keyword : keyword,
      });

    });
  });

  var remove_all = document.querySelector('.js-publications-remove-all-filters');
  remove_all.addEventListener('click', (e) => {

    cator = reset_cator(cator);    
    reset_catand(catand_filter);

    catand = false;
    tag = false;
    keyword = false;

    get_publications({
      cator : cator,
      catand : catand, 
      tag : tag,
      date : false, 
      keyword : false,
    });

  });

  click_loadmore();

  const query_string = decodeURIComponent(window.location.search);
  const url_params = new URLSearchParams(query_string);

  if(url_params.has('categorie')){

    const cat = url_params.get('categorie');
    document
    .querySelector('#sidebar-filter-cat')
    .querySelector('#' + cat)
    .click();

  }

  if(url_params.has('tag')){

    const tag = url_params.get('tag');
    document
    .querySelector('#sidebar-filter-tag')
    .querySelector('#' + tag)
    .click();

  }

  if(url_params.has('search')){

    document
    .querySelector('.js-search-keyword')
    .click();

  }
  
})()